// extracted by css-extract-rspack-plugin
export default {"number":"product-detail-fragment__HowItWorks_number__WBD0O","title":"product-detail-fragment__HowItWorks_title__fMlUs"};